/************************************
MODULE:         Simple Popup
WHAT IT DOES:   Simple popup without quote complex animations
*************************************/
(function (root, factory) {
    if (typeof define === 'function' && define.amd) {
        define(['jquery'], factory);
    }
    else if (typeof exports === 'object') {
        module.exports = factory(require('jquery'));
    }
    else {
        root.returnExports = factory(root.jQuery);
    }
}(this, function ($) {
    var popupContainer,
        popupContainerInner,
        tween = null,
        isOpened = false,
        templates,
        isInited = false,
        options;


    function init() {
        if (isInited)
            return;
        isInited = true;

        popupContainer = $('.js-simple-popup-container');
        popupContainerInner = $('.js-simple-dialog-inner');

        if (!popupContainer.length || !popupContainerInner.length)
            return;

        require('tweenmax');

        templates = require.context("../../../templates/popup/", true, /^\.\/.*\.handlebars$/);

        $(document).on('click', '.js-simple-popup-close', close);
        popupContainer.on('click touchstart', clickPopup);
        $(window).on('open:simplepopup', open);
        $(window).on('close:simplepopup', close);
        $(window).on('resize:finished', resize);

    }

    function open(e, data) {
        if (typeof e != 'undefined' && typeof e.preventDefault == "function")
            e.preventDefault();

        if (typeof data != 'undefined') {
            options = data;
            var tempalteCompiled = templates("./" + data.template + ".handlebars");
            popupContainerInner.html(tempalteCompiled(data.data));
            $(window).trigger('video:init');
        }

        if (isOpened)
            return;
        isOpened = true;

        var main = $('.js-main'),
            maxWidth = main.outerWidth();
        main.add(popupContainer).css('max-width', maxWidth);
        $('html').addClass('simple-popup-opened');
        if(data && data.cssClass){
            popupContainer.addClass(data.cssClass);
        }


        tweenPromote(tween);
        tween = new TimelineMax();
        tween.to(popupContainer, 0.0, { visibility: "visible", bottom: '0' });
        tween.to(popupContainer, 0.5, { opacity: 1 });
        tween.play();
    }

    function close(e, data) {
        if (typeof e != 'undefined' && typeof e.preventDefault == "function")
            e.preventDefault();
        if (!isOpened)
            return;
        isOpened = false;

        popupContainer.find('.js-video').trigger('video:remove');

        tweenPromote(tween);
        tween = new TimelineMax({onComplete: closeAnimationEnd});
        tween.to(popupContainer, 0.5, { opacity: 0 });
        tween.to(popupContainer, 0.0, { visibility: "visible", bottom: 'auto' });
        tween.play();

        if(options && options.cssClass){
            popupContainer.removeClass(options.cssClass);
        }
        $('html').removeClass('simple-popup-opened');
    }

    function closeAnimationEnd() {
        $(window).trigger('closed:simplepopup');
    }

    function clickPopup(e) {
        if (!isOpened)
            return;

        var target = $(e.target);
        if (!target.hasClass('js-simple-dialog-inner') && !target.parents('.js-simple-dialog-inner').length)
            close();
    }

    function resize() {
        $('.js-main').add(popupContainer).css('max-width', '');
    }

    function tweenPromote(tween) {
        if (typeof tween == 'undefined' || tween == null)
            return;

        if (typeof tween.progress == 'function' && tween.progress() < 1) {
            tween.pause();
            tween.progress(1);
        }

        if (typeof tween.destroy == 'function') {
            tween.destroy();
        }
    }



    return {
        init: init
    };

}));


/*****************
 ** WEBPACK FOOTER
 ** ./js/app/modules/app.simplepopup.js
 ** module id = 58
 ** module chunks = 24
 **/